<template>
  <UIButtonIcon
    :leading="ArrowDownLeftIcon"
    variant="gray"
    fill="light"
    type="button"
    size="sm"
    class="ui-drawer-minimize-button"
  />
</template>

<script setup lang="ts">
import { UIButtonIcon } from '@ui/buttons'

import { ArrowDownLeftIcon } from '@heroicons/vue/24/outline'
</script>

<style>
.ui-drawer-minimize-button {
  @apply hidden sm:block;
}
</style>
